var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullRevert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24764 7.33769L6.32201 6.75487C6.49705 5.3889 7.07646 4.12132 7.97385 3.14119C8.87123 2.16106 10.0385 1.5209 11.3016 1.31616C12.5646 1.11143 13.8558 1.35311 14.9826 2.00515C16.1093 2.65718 17.0112 3.68465 17.5538 4.9343C18.0964 6.18396 18.2506 7.58885 17.9934 8.93944C17.7362 10.29 17.0814 11.514 16.1266 12.4287C15.1718 13.3435 13.9682 13.9 12.6954 14.0153C11.4225 14.1306 10.1485 13.7986 9.06343 13.0687",
    stroke: "#F1416C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30577 10.6529L3.00253 3.62922L9.86543 6.55333L4.30577 10.6529Z",
    fill: "#F1416C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullRevert);
export default __webpack_public_path__ + "static/media/fullRevert.abc49d33d57ba6cff873bde5e7517c8c.svg";
export { ForwardRef as ReactComponent };